{
  "codeExpired": "Le code que vous avez entré est expiré.",
  "codeInvalid": "Le code que vous avez saisi n'est pas valide. Veuillez vérifier et réessayer.",
  "decimalNumber": "Ce champ doit être un nombre.",
  "deviceLocationUnknown": "Emplacement de l'appareil inconnu.",
  "integerOnly": "Ce champ doit être un nombre entier.",
  "maxLengthWithVal": "Trop de caractères ({{val}} maximum)",
  "maxValueWithVal": "Cette valeur doit être inférieure ou égale à {{val}}.",
  "minLength": "doit contenir au moins {{minLength}} caractères.",
  "minValueWithVal": "Cette valeur doit être au moins égale à {{val}}.",
  "passwordRulesLowercaseCount": "Le mot de passe doit contenir au moins une lettre minuscule.",
  "passwordRulesMinLength": "Le mot de passe doit comporter au moins 8 caractères.",
  "passwordRulesMustMatch": "Les mots de passe doivent correspondre.",
  "passwordRulesNumericCount": "Le mot de passe doit contenir au moins un chiffre.",
  "passwordRulesSpecialCharacterCount": "Le mot de passe doit contenir au moins un caractère spécial (!@#$$^&*)",
  "passwordRulesUppercaseCount": "Le mot de passe doit contenir au moins une lettre majuscule.",
  "required": "Ce champ est obligatoire."
}
